import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import React, { useCallback, useState } from 'react'

interface PnrBadgeProps {
    pnr: string
    compact?: boolean
}

const PnrBadge: React.FC<PnrBadgeProps> = ({ pnr, compact }) => {
    const t = useTranslations('tripDetails')
    const [copied, setCopied] = useState(false)

    const handleCopy = useCallback(() => {
        if (!pnr) return
        navigator.clipboard.writeText(pnr).then(() => {
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        })
    }, [pnr])

    if (!pnr) return null

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                px: 1.5,
                py: 0.75,
                borderRadius: '8px',
                bgcolor: 'primary.100'
            }}
        >
            <Typography
                variant="body2"
                component="span"
                sx={{
                    fontWeight: 500,
                    color: 'text.primary',
                    fontSize: compact ? 12 : 14
                }}
            >
                {t('pnrPrefix')}:{' '}
                <Typography component="span" sx={{ fontWeight: 700, fontSize: compact ? 12 : 14 }}>
                    {pnr}
                </Typography>
            </Typography>
            <Tooltip title={copied ? t('copied') : t('copyPnr')}>
                <IconButton
                    size="small"
                    onClick={handleCopy}
                    sx={{
                        p: 0.25,
                        color: 'text.primary',
                        '& .MuiSvgIcon-root': { fontSize: 14, opacity: 0.7 }
                    }}
                    aria-label={t('copyPnr')}
                >
                    <ContentCopyIcon />
                </IconButton>
            </Tooltip>
        </Box>
    )
}

export default PnrBadge
